import React from "react"
import { RouteComponentProps } from "@reach/router"
import { IFrame } from "../../integration/iframe"

interface Props extends RouteComponentProps {
  id?: string
}

export const ReferralsEndorsements: React.FC<Props> = ({ id = `` }) => (
  <>
    <IFrame path={`referrals/${id}/endorsements`} />
  </>
)

ReferralsEndorsements.defaultProps = {
  id: ``,
}
